const CopyrightFooter = () => {
  return (
    <div
      className="copyright text-center"
      style={{
        background: 'linear-gradient(180deg, #fffaf2 0%, #fff5e6 100%)',
        padding: '15px 0',
        borderTop: 'none',
        borderBottom: 'none',
      }}
    >
      <p style={{ color: '#333', fontSize: '14px', margin: '0 0 5px 0' }}>
        &copy; {new Date().getFullYear()} TAK8 Car Rental. All Rights Reserved.
      </p>
      <p style={{ fontSize: '13px', margin: 0 }}>
        <a
          href="https://ezilab.io/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <span className="colorYellow">Powered by </span>
          <span style={{ fontWeight: 'bold', color: '#0d6efd' }}>Ezilab.io</span>
        </a>
      </p>
    </div>
  );
};

export default CopyrightFooter;
